'use client';

var DELAY_TIMEOUT = 200;

export { DELAY_TIMEOUT };
//# sourceMappingURL=const.js.map
